import { chevron_Icon } from "../../assets/icons";
import { globals, images } from "../../styles";
import styles from "./MainPage.module.css";

export function LineupPager(props: {
  handleCurrentLineupClicked: () => void;
  handleNextLineupClicked: () => void;
  isViewingCurrentLineup: boolean;
  gameweekLabel: string;
  isNewLineup: boolean;
}) {
  const {
    handleCurrentLineupClicked,
    handleNextLineupClicked,
    isViewingCurrentLineup,
    gameweekLabel,
    isNewLineup,
  } = props;

  const handleLeft = () => {
    if (!isViewingCurrentLineup) handleCurrentLineupClicked();
  };

  const handleRight = () => {
    if (isViewingCurrentLineup) handleNextLineupClicked();
  };

  return (
    <div className={styles["pager"]}>
      <button className={globals["button-wrapper"]} onClick={handleLeft}>
        <div
          className={`${styles["pager-arrow"]} ${isViewingCurrentLineup ? styles["pager-arrow--disabled"] : ""}`}
        >
          {!isNewLineup && (
            <img
              alt="left"
              src={chevron_Icon}
              className={images["pager-arrow-icon--left"]}
            />
          )}
        </div>
      </button>
      <div className={styles["pager-center"]}>
        <span className={styles["pager-title"]}>
          {isViewingCurrentLineup && !isNewLineup
            ? "Current Lineup"
            : "Next Week's Lineup"}
        </span>
        <span className={styles["pager-subtitle"]}>{gameweekLabel}</span>
      </div>
      <button className={globals["button-wrapper"]} onClick={handleRight}>
        <div
          className={`${styles["pager-arrow"]} ${!isViewingCurrentLineup ? styles["pager-arrow--disabled"] : ""}`}
        >
          {!isNewLineup && (
            <img
              alt="right"
              src={chevron_Icon}
              className={images["pager-arrow-icon"]}
            />
          )}
        </div>
      </button>
    </div>
  );
}

export default LineupPager;
